import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/imgs/headshots/derek-crane.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Photo of Derek Crane"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Derek Crane"),
  /*#__PURE__*/_createElementVNode("h3", null, "COO | PAG Consulting"),
  /*#__PURE__*/_createElementVNode("p", null, "Mr.Crane is a Partner and Group Chief Operating Officer of PAG, one of Asia’s largest independent alternative investment management firms. Mr Crane has extensive experience in financial services and fund management. Prior to joining PAG in 2007, Mr.Crane held positions with ICAP Plc as CFO for Asia based in Hong Kong, and with UBS AG in Jersey Channel Islands as a Director responsible for fund structuring and administration. Mr.Crane is a FCMA, FCSI & FHKSI.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_profile = _resolveComponent("profile")!

  return (_openBlock(), _createBlock(_component_profile, null, {
    headshot: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }))
}